export interface ArticleListItem {
  id: string;
  name: string;
  publishDate: string;
  url: string;
  metaData: {
    key: string;
    value: string;
  }[];
}

export const apiStates = {
  FETCHING: 'fetching',
  HAS_ERROR: 'has_error',
  READY: 'ready',
} as const;

export type State = (typeof apiStates)[keyof typeof apiStates];

export interface ArticleListResponseResult extends Array<ArticleListItem> {}

export interface CategoryListResponse extends Array<string> {}

export interface AccountInformationResponse {
  ipAuth: boolean;
  ipRights: boolean;
  almaAuth: boolean;
  almaRights: boolean;
  organization?: string;
}

export type ArticleParams = {
  page?: number;
  limit?: number;
  category?: string;
  author?: string;
  orderBy?: string;
  contentType?: string[] | string;
  includeUpcoming?: boolean;
  upcoming?: boolean;
};

export type ArticleListResponse = {
  page: number;
  count: number;
  result: ArticleListResponseResult;
};

export type ArticleResponse = {
  restricted: boolean;
  authenticated: boolean;
  upcoming: boolean;
  article: string;
};

export interface Category {
  name: string;
  path: string;
}

export const CONTENT_TYPE = {
  Article: 'Artikkeli',
  Overview: 'Katsaus',
  CaseCommentary: 'Oikeustapauskommentti',
  ShortLegalNews: 'Juridiikkaa lyhyesti',
  LegalNews: 'Uutinen',
} as const;

export type ContentType = (typeof CONTENT_TYPE)[keyof typeof CONTENT_TYPE];

export const defaultContentTypes: ContentType[] = [
  CONTENT_TYPE.Article,
  CONTENT_TYPE.CaseCommentary,
  CONTENT_TYPE.Overview,
  CONTENT_TYPE.ShortLegalNews,
];

export const contentTypePluralToOneMap: Record<string, ContentType> = {
  Artikkelit: CONTENT_TYPE.Article,
  Katsaukset: CONTENT_TYPE.Overview,
  'Juridiikkaa lyhyesti': CONTENT_TYPE.ShortLegalNews,
  Oikeustapauskommentit: CONTENT_TYPE.CaseCommentary,
};

export const ARTICLE_LANGUAGE = {
  FI: 'fi',
} as const;

export type ArticleLanguage =
  (typeof ARTICLE_LANGUAGE)[keyof typeof ARTICLE_LANGUAGE];

export interface CategoryMeta {
  primary: string;
  secondary: string[];
}

export const defaultCoverImageAspectRatio = 3 / 2;
